import { IonList } from '@ionic/react';
import { Form, Formik, FormikHelpers } from 'formik';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import {
  UpdateEventDefinitionInput,
  useUpdateEventDefinitionMutation,
} from '../../api/graphql/generated';
import { AutoSave } from '../form/AutoSave';
import { IonFormField } from '../form/ion-form.field';
import { SaveStatusToast } from '../toast/toast.gql';

interface Form {
  label?: string;
}

interface EventDefinitionFormProps {
  form: UpdateEventDefinitionInput;
}

const EventDefinitionForm = ({
  form,
}: EventDefinitionFormProps): ReactElement => {
  const { i18n } = useTranslation();
  const editEventDefinitionSchema = yup.object().shape({
    label: yup
      .string()
      .required(i18n.t('common:event_definition_invalid_label')),
  });
  const [updateEventDefinition, { loading, error }] =
    useUpdateEventDefinitionMutation();

  const saveForm = async (
    input: UpdateEventDefinitionInput,
    helpers: FormikHelpers<UpdateEventDefinitionInput>
  ) => {
    try {
      await updateEventDefinition({
        variables: {
          input,
        },
      });
    } catch {
      helpers.resetForm();
    }
  };

  return (
    <>
      <Formik
        initialValues={form}
        onSubmit={saveForm}
        validationSchema={editEventDefinitionSchema}
        validateOnMount={true}
      >
        <Form>
          <IonList>
            <IonFormField
              name="label"
              label={i18n.t('common:event_definition_custom_label')}
            ></IonFormField>
          </IonList>
          <AutoSave />
        </Form>
      </Formik>
      <SaveStatusToast loading={loading} error={error} />
    </>
  );
};

export { EventDefinitionForm };
